export enum TableTypes {
  SINGLE = 'SINGLE',
  DOUBLE = 'DOUBLE',
  TRIPLE = 'TRIPLE',
  QUAD = 'QUAD',
  CUSTOM = 'CUSTOM',
}

export enum TableStates {
  FREE = 'FREE',
  PREPARE = 'PREPARE',
  READY = 'READY',
  SEATED = 'SEATED',
  RESERVED = 'RESERVED',
}

export const TABLE = 'TABLE';

export const ALL_TABLE_STATES = [TableStates.FREE, TableStates.READY, TableStates.SEATED, TableStates.RESERVED];
